<template>
  <div class="row justify-content-md-center">
    <b-modal
      id="new-company"
      ref="editPasswordRef"
      :hide-header="true"
      size="md">
      <div class="col">
        <h3>修改密码</h3>
        <div class="input-group">
          <div class="input-group-prepend">
            <span class="input-group-text">原始密码</span>
          </div>
          <input type="password" class="form-control" v-model='old'>
        </div>

        <div class="input-group mb-3"> 
          <div class="input-group-prepend">
            <span class="input-group-text">新密码</span>
          </div>
          <input v-validate="'required'" v-model='new1' name="password" type="password" class="form-control" :class="{'is-invalid': errors.has('password_confirmation')}" ref="password">

        </div>
        <div class="input-group mb-3">
          <div class="input-group-prepend">
            <span class="input-group-text">重复密码</span>
          </div>
          <input v-validate="'required|confirmed:password'" v-model="new2" name="password_confirmation" type="password" class="form-control" :class="{'is-invalid': errors.has('password_confirmation')}">
        </div>
      </div>
      <div slot="modal-footer" class="w-100">
        <button class="btn btn-primary float-right mx-5" @click="changePassword">提交</button>
        <button class="btn btn-secondary float-right" @click="$refs.editPasswordRef.hide();">取消</button>
     </div>
    </b-modal>
  </div>
</template>

<script>
import {showSuccessAlert} from '@/utils/alert'

function showEditPasswordModal () {
  this.$refs.editPasswordRef.show()
}

function changePassword () {
  this.$validator.validateAll().then((result) => {
    if (!result) {
      return
    }
    this.$http.post('/api/password', {
      old_password: this.old,
      new_password: this.new1
    }).then((response) => {
      if (response) {
        setTimeout(
          () => {
            showSuccessAlert('请重新登录')
          }, 500)
        this.$refs.editPasswordRef.hide()
        this.$emit('doLogout')
        this.emit('refresh')
      }
    })
  })
}

export default {
  name: 'password',
  data () {
    return {
      old: '',
      new1: '',
      new2: ''
    }
  },
  methods: {
    showEditPasswordModal,
    changePassword
  }
}
</script>